import { normalizeParts } from '@tunasong/schemas'

/** The part-set fields of the user's private `performance` config; other fields pass through untouched */
export interface PerformanceParts {
  defaultParts?: string[]
  partsByBand?: Record<string, string[]>
}

/** The parts a member plays in a band: the band's set, else their default. Full chart is not an instrument. */
export const bandParts = (performance: PerformanceParts | undefined, bandId: string) =>
  (normalizeParts(performance?.partsByBand?.[bandId]) ?? normalizeParts(performance?.defaultParts) ?? []).filter(
    part => part !== 'full'
  )
